import { render } from "./Divider.vue?vue&type=template&id=99c5b368"
const script = {}

import exportComponent from "/Users/jgividen/Local Sites/aph-font-testing/app/public/wp-content/plugins/aph-font-app/assets/js/component-lib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__